import React, { useEffect , useContext, useRef } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * 不動産情報APIのvectorタイルのクリック時の表示用マーカー
 * タイルクリック時にポップアップを自動表示するためにrefを使用している。
 * 
 * @param feature
 * @param menu
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({latitude, longitude, feature, option, closePopup}) => {
  
  const { state } = useContext(Context);
  const markerRef = useRef(null);
  
  useEffect(() => {
    
    // 変化があるごとにポップアップを自動表示
    if (markerRef.current) {
      markerRef.current.openPopup();
    }
  });

  const icon = menu2icon[option.id] || menu2icon["default"]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handlePopupClose = () => {
    if (markerRef.current) {
      // Leafletのマーカーポップアップを閉じる
      // markerRef.current.closePopup();
    }

    closePopup();
  }
  // ポップアップの表示内容の加工
  const createPopupContent = (feature, option) => {

    let ret = []
    
    // 小学校区
    if (option.fetchedServerKey === "XKT004") {

      ret.push(<dl className='dl-list is-modal-spot'><dt>設置主体</dt><dd>{feature.A27_002}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.A27_004_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.A27_005}</dd></dl>)

    } else if (option.fetchedServerKey === "XKT005") {

      ret.push(<dl className='dl-list is-modal-spot'><dt>設置主体</dt><dd>{feature.A32_002}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.A32_004_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.A32_005}</dd></dl>)

    } else if (option.fetchedServerKey === "XKT001") {

      const XKT001_CODE = {
        "21":"都市計画区域",
        "22":"市街化区域",
        "23":"市街化調整区域",
      }

      let kubunId = feature.kubun_id.toString()

      ret.push(<dl className='dl-list is-modal-spot'><dt>区分コード</dt><dd>{XKT001_CODE[kubunId]}</dd></dl>)
      
    } else if (option.fetchedServerKey === "XKT002") {
    
      // 用途地域

      const XKT002_CODE = {
        "1":"第1種低層住居専用地域",
        "2":"第2種低層住居専用地域",
        "3":"第1種中高層住居専用地域",
        "4":"第2種中高層住居専用地域",
        "5":"第1種住居地域",
        "6":"第2種住居地域",
        "7":"準住居地域",
        "8":"田園住居地域",
        "9":"近隣商業地域",
        "10":"商業地域",
        "11":"準工業地域",
        "12":"工業地域",
        "13":"工業専用地域",
      }


      let youtoId = feature.youto_id.toString()

      ret.push(<dl className='dl-list is-modal-spot'><dt>用途地域分類</dt><dd>{XKT002_CODE[youtoId]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>容積率</dt><dd>{feature.u_floor_area_ratio_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>建蔽率</dt><dd>{feature.u_building_coverage_ratio_ja}</dd></dl>)
      
    } else if (option.fetchedServerKey === "XKT014") {
    
      // 防火地域及び準防火地域

      ret.push(<dl className='dl-list is-modal-spot'><dt>区分コード</dt><dd>{option.label}</dd></dl>)
      
    }  else if (option.fetchedServerKey === "XKT023") {
    
      ret.push(<dl className='dl-list is-modal-spot'><dt>区分コード</dt><dd>{option.label}</dd></dl>)
      
      
    } else if (option.fetchedServerKey === "XKT024") {
    
      ret.push(<dl className='dl-list is-modal-spot'><dt>区分コード</dt><dd>{option.label}</dd></dl>)
      
      
    } else if (option.fetchedServerKey === "XKT003") {
    
      ret.push(<dl className='dl-list is-modal-spot'><dt>区域コード</dt><dd>{option.label}</dd></dl>)
    }

    return ret
  }

  // 複数のfeaturesデータが同じgeojsonに含まれているので必要なデータのみ表示する。
  let isTarget = false

  // 学校データ
  if (option.fetchedServerKey === "XKT004"
     || option.fetchedServerKey === "XKT005"
     || option.fetchedServerKey === "XKT001"
     || option.fetchedServerKey === "XKT002"
     || option.fetchedServerKey === "XKT003"
     || option.fetchedServerKey === "XKT014"
     || option.fetchedServerKey === "XKT023"
     || option.fetchedServerKey === "XKT024"
    ) {
    isTarget = true

  }

  if(isTarget && 
    latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}  
          ref={markerRef}
        >
          <Popup
            autoPan={true}
            keepInView={true}    
            autoPanPadding={L.point(30, 70)}
            onClose={handlePopupClose}
            >
            {
              createPopupContent(feature, option)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
